import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import { stemExtensionsDataActions } from '.';
import { priceActions } from 'app/features/price/slice';
import { stockActions } from 'app/features/stock/slice';
import {
  selectErpSystem,
  selectLanguage,
} from 'app/features/erpSystem/slice/selectors';
import {
  selectPaginationLimit,
  selectPaginationSkip,
} from 'app/features/pagination/slice/selectors';
import { selectSavedItem } from 'app/features/selectedItem/slice/selectors';
import { getRequestPayload, transformStemExtensionData } from './utils';
import { selectSearch } from 'app/features/search/slice/selectors';
import { selectPriceResponse } from 'app/features/price/slice/selectors';
import { selectStockResponse } from 'app/features/stock/slice/selectors';
import { StemExtensionsResponse } from './types';

function* fetchStemExtensionData() {
  const { getStemExtensionsDataSuccess, getStemExtensionsDataFail } =
    stemExtensionsDataActions;

  const { getPriceData } = priceActions;
  const { getStockStatus } = stockActions;
  const language = yield select(selectLanguage);
  const limit = yield select(selectPaginationLimit);
  const skip = yield select(selectPaginationSkip);
  const selectedValveItem = yield select(state => selectSavedItem(state, 1));
  const query = yield select(selectSearch);
  const erpSystem = yield select(selectErpSystem);

  try {
    const payload = getRequestPayload(
      language,
      limit,
      skip,
      selectedValveItem,
      query,
      erpSystem,
    );
    const stemExtensionData = yield call(
      fetch,
      `/valve-configurator/api/stemExtensions`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );
    if (stemExtensionData.status !== 200) {
      return yield put(getStemExtensionsDataFail('Failed to fetch data'));
    } else {
      const data: StemExtensionsResponse = yield stemExtensionData.json();
      if (!data) {
        return yield put(getStemExtensionsDataFail('No items fetched'));
      }
      let itemsPriceData: any = {};
      let itemsStockData: any = {};

      if (data.items.length) {
        yield put(getPriceData(data.items));
        yield take(['price/getPriceDataSuccess', 'price/getPriceDataFail']);
        itemsPriceData = yield select(selectPriceResponse);

        yield put(getStockStatus(data.items));
        yield take(['stock/getStockStatusSuccess', 'stock/getStockStatusFail']);
        itemsStockData = yield select(selectStockResponse);
      }

      const transformedData = transformStemExtensionData(
        data.items[0],
        itemsPriceData,
        itemsStockData,
      );
      return yield put(
        getStemExtensionsDataSuccess({ ...data, ...transformedData }),
      );
    }
  } catch (e) {
    yield put(getStemExtensionsDataFail(e));
  }
}

export function* stemExtensionsDataSaga() {
  yield takeLatest(
    stemExtensionsDataActions.getStemExtensionsData.type,
    fetchStemExtensionData,
  );
}
